module.exports = __webpack_public_path__ + "static/media/julien-sarazin-n3mK4n_nF7g-unsplash.c6c6c30d.jpg";